import React from 'react';

import { FACE_OCCLUSION_STATE_OPTIONS_STRICT } from '@vlabs/api-bindings/src/constants';
import validate from '@vlabs/shared/validators';
import { Control, SettingsItemWrapper, Fold } from '@vlabs/uikit';
import { useFormContext, useWatch, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import './FaceOcclusionSubForm.sass';

function FaceOcclusionSubForm() {
  const { t } = useTranslation();
  const { register, control } = useFormContext();
  const { errors } = useFormState();
  const isEstimateFaceOcclusion = useWatch({ name: 'estimate_face_occlusion.estimate' });
  const stateThresholdsArray = ['hair_occlusion_threshold', 'occlusion_threshold', 'forehead_threshold',
    'eye_threshold', 'nose_threshold', 'mouth_threshold', 'lower_face_threshold'];

  return (
    <Fold
      control={control}
      isOpen={isEstimateFaceOcclusion}
      name="estimate_face_occlusion.estimate"
      switch
      testId="estimate_face_occlusion"
      title={t('handlers:policies.detect_policy.estimate_face_occlusion.estimate')}
    >

      <SettingsItemWrapper
        contentClassName="MatchPolicy_Dropdown"
        title={t('handlers:policies.detect_policy.face_occlusion_states')}
      >
        <Control.Select
          control={control}
          errors={errors}
          isMulti
          name="estimate_face_occlusion.face_occlusion_states"
          options={FACE_OCCLUSION_STATE_OPTIONS_STRICT.raw}
        />
      </SettingsItemWrapper>

      {stateThresholdsArray.map((label) => (
        <SettingsItemWrapper
          contentClassName="MatchPolicy_Input"
          key={label}
          title={t(`handlers:policies.detect_policy.estimate_face_occlusion.${label}.label`)}
        >
          <Control.Input
            {...register(`estimate_face_occlusion.${label}`, {
              min: validate.gte(0),
              max: validate.lte(1),
              validate: validate.number(),
            })}
            errors={errors}
          />
        </SettingsItemWrapper>
      ))}

    </Fold>
  );
}

export default FaceOcclusionSubForm;
